/**
 * icon_map.js
 * Universal Icon Resolver for Madmoco Toolboxes.
 * Dynamically resolves icons from @phosphor-icons/react.
 */

import React from 'react';
import * as Icons from '@phosphor-icons/react';

/**
 * Converts slug_case to PascalCase
 * example: "arrow_square_out" -> "ArrowSquareOut"
 */
const toPascalCase = (str) => {
  if (!str) return '';
  return str
    .split(/[_-]/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join('');
};

/**
 * Universal icon resolver.
 */
export const get_icon = (icon_name, size = 18, weight = 'bold', returnNullIfMissing = false) => {
  if (!icon_name) return null;

  const pascalName = toPascalCase(icon_name);
  const IconComponent = Icons[pascalName] || Icons[icon_name];

  if (!IconComponent) {
    return returnNullIfMissing ? null : <Icons.Cube size={size} weight={weight} />;
  }

  return <IconComponent size={size} weight={weight} />;
};

/**
 * Category icon resolver.
 * Priority: 
 * 1. Explicit icon name provided in module metadata
 * 2. Icon matching the category name exactly
 * 3. Default fallback (Cube)
 */
export const get_category_icon = (category, explicit_icon) => {
  // 1. If explicit icon name provided, use it.
  if (explicit_icon) return get_icon(explicit_icon);

  // 2. Try to find an icon that matches the category name exactly (e.g. Category "Nut" -> Nut Icon)
  const exactMatch = get_icon(category, 18, 'bold', true);
  if (exactMatch) return exactMatch;

  // 3. Ultimate fallback
  return <Icons.Cube size={18} weight="bold" />;
};

export default get_icon;
